// TODO:
export const baseURL = "/";
